import React from 'react';
import {BaseTracker, BaseTrackerProps} from './BaseTracker';
import {Promotion, usePromotionTracking} from './TrackPromotions';

// The hero brand slider renders a single card that updates its content based on the active brand.
// During transitions, both old and new brands are in the DOM simultaneously (FadeTransition).
// We use a shared Set to track impressions across all instances to prevent duplicate tracking,
// especially when both old (fading out) and new (fading in) brands are visible during transitions.
const trackedImpressions = new Set<string>();

export const TrackHeroBrandsSlider: React.FC<
  Omit<BaseTrackerProps, 'track' | 'trackingKey'> & {
    horizontalPosition: number;
    promotion: Promotion;
    streamPosition: number;
    trackingKey: string;
  }
> = ({
  children,
  horizontalPosition,
  promotion,
  streamPosition,
  trackingKey,
  ...rest
}) => {
  const trackPromotion = usePromotionTracking({
    promotion,
    streamPosition,
    horizontalPosition,
  });

  const handleTrack = (type: 'impression' | 'click') => {
    trackPromotion(type);

    if (type === 'impression') {
      trackedImpressions.add(trackingKey);
    }
  };

  return (
    <BaseTracker
      triggerOnce
      track={handleTrack}
      trackingKey={trackingKey}
      disabled={trackedImpressions.has(trackingKey)}
      {...rest}
    >
      {children}
    </BaseTracker>
  );
};

export const useTrackHeroBrandSliderAdditionalTilePromotion = ({
  promotion,
  streamPosition,
  horizontalPosition,
}: {
  promotion: Promotion;
  streamPosition: number;
  horizontalPosition: number;
}) => {
  return usePromotionTracking({
    promotion,
    streamPosition,
    horizontalPosition,
  });
};
